import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {AuthGuard} from './shared/guard/auth.guard';
import {PagesResolver} from './pages/pages.resolver';
import {UserService} from './pages/user.service';

const routes: Routes = [
  {
    path: '',
    loadChildren: './pages/pages.module#PagesModule',
    resolve: {user: PagesResolver},
    canActivate: [AuthGuard]
  },
  {path: 'login', loadChildren: './login/login.module#LoginModule'},
  {path: 'signup', loadChildren: './signup/signup.module#SignupModule'},
  {path: '404', loadChildren: './404/not-found.module#NotFoundModule'},
  {path: '**', redirectTo: '404'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true }), NgbModule.forRoot()],
  exports: [RouterModule],
  providers:[
    PagesResolver,
    UserService
  ]
})
export class AppRoutingModule {
}



// WEBPACK FOOTER //
// D:/projects/feelway-pawnshop/pawnshop-web-client-feelway/src/app/app-routing.module.ts